import { inject, Injectable } from '@angular/core';
import { MmuUserService, DateFormat } from '@move/core';
import { MuiConfiguration, MuiDatepickerV2Format } from '@move/ui';
import { filter } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';


@Injectable()
export class MuiConfigurationImpl implements MuiConfiguration {
  dateFormat: MuiDatepickerV2Format = 'YYYY-MM-DD';

  private userService = inject(MmuUserService);

  constructor() {
    this.linkDateFormatToUserPreferences();
  }

  private linkDateFormatToUserPreferences(): void {
    // Change the Datepicker format based on the user's preferences whenever it changes
    this.userService.user$.pipe(
      map(user => user.prefs?.dateFormat),
      filter((format): format is DateFormat => !!format),
      distinctUntilChanged()
    ).subscribe(format => {
      // Map the different formats from the backend to the formats used by the Datepicker
      switch (format) {
        case DateFormat.DD_MM_YYYY_MINUS:
          this.dateFormat = 'DD-MM-YYYY';
          break;
        case DateFormat.YYYY_MM_DD_MINUS:
          this.dateFormat = 'YYYY-MM-DD';
          break;
        case DateFormat.MM_DD_YYYY_SLASH:
          this.dateFormat = 'MM/DD/YYYY';
          break;
        case DateFormat.DD_MM_YYYY_SLASH:
          this.dateFormat = 'DD/MM/YYYY';
          break;
        default:
          this.dateFormat = 'DD.MM.YYYY';
      }
    });
  }
}
